(function () {
  'use strict';

  // --- Consent Helper (reads the record persisted by termly-bridge.js) ---
  function hasAnalyticsConsent() {
    try {
      var status = localStorage.getItem('termly-consent-status');
      if (status === 'accepted') return true;
      if (status === 'custom') {
        var cats = JSON.parse(localStorage.getItem('termly-consent-categories') || 'null');
        return !!(cats && cats.analytics === true);
      }
    } catch (e) {}
    return false; // declined, unknown or unreadable: fail closed
  }

  // --- Lead attribution, first touch (JORS-3813) ---
  // Held in memory for the page only: nothing is stored on the visitor's device
  // (BO decision 19/09/2026). The FR/EN switcher carries the values in the URL.
  var ATTR_UTM = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var ATTR_FIELDS = ATTR_UTM.concat(['referrer', 'landing_path']);
  var ATTR_MAX = 500;

  function attrClean(v) {
    try {
      v = (v == null ? '' : String(v)).replace(/[\u0000-\u001F\u007F]/g, '').trim();
      return v.length > ATTR_MAX ? v.slice(0, ATTR_MAX) : v;
    } catch (e) {
      return '';
    }
  }

  function isOwnHost(host) {
    return host === 'joraleka.com' || /\.joraleka\.com$/.test(host);
  }

  function captureFirstTouch() {
    var a = {};
    ATTR_FIELDS.forEach(function (k) { a[k] = ''; });
    try {
      var params = new URLSearchParams(window.location.search);
      ATTR_UTM.forEach(function (k) { a[k] = attrClean(params.get(k)); });

      if (params.has('jl_ref') || params.has('jl_lp')) {
        // Carried by the FR/EN switcher from the first page of the visit.
        a.referrer = attrClean(params.get('jl_ref'));
        a.landing_path = attrClean(params.get('jl_lp'));
      } else {
        var ref = '';
        try {
          var r = new URL(document.referrer);
          if (!isOwnHost(r.hostname)) ref = r.origin + r.pathname;
        } catch (e) { /* no referrer or not a URL */ }
        a.referrer = attrClean(ref);
        a.landing_path = attrClean(window.location.pathname);
      }
    } catch (e) { /* keep whatever was read; never block */ }
    return a;
  }

  var attrFirstTouch = captureFirstTouch();

  function getAttribution() {
    var out = {};
    ATTR_FIELDS.forEach(function (k) { out[k] = attrFirstTouch[k] || ''; });
    return out;
  }

  // Read by the FR/EN switcher below, outside this closure.
  window.joraGetAttribution = getAttribution;

  // --- Tracking Helper ---
  function trackEmailSubmission(statusString) {
    if (!hasAnalyticsConsent()) return;
    var lang = (document.documentElement.lang || 'en').toLowerCase().startsWith('fr') ? 'fr' : 'en';
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'landing_email_submission_click',
      'status': statusString,
      'pageLanguage': lang,
      'pagename': 'landing'
    });
  }

  // --- Conversion events (JORS-3778) ---
  // Sent through gtag() only after consent (hasAnalyticsConsent), never before.
  // No personal data in the payload: no email, name, store URL or message.
  function trackConversion(eventName, extra) {
    if (!hasAnalyticsConsent()) return;
    if (typeof window.gtag !== 'function') return;
    var params = {
      page_language: (document.documentElement.lang || 'en').toLowerCase().startsWith('fr') ? 'fr' : 'en',
      page_name: 'landing'
    };
    if (extra) Object.keys(extra).forEach(function (k) { params[k] = extra[k]; });
    window.gtag('event', eventName, params);
  }

  // primary_cta_click: the hero call to action (the only .mvp-cta-primary on the page).
  document.addEventListener('click', function (e) {
    if (e.target.closest('.mvp-cta-primary')) trackConversion('primary_cta_click', { cta_location: 'hero' });
  }, false);

  /* ---------- Smooth scroll for anchor CTAs ---------- */
  document.addEventListener('click', function (e) {
    var target = e.target.closest('[data-jora-scroll]');
    if (!target) return;
    var id = target.getAttribute('data-jora-scroll') || target.getAttribute('href').replace(/^#/, '');
    var el = document.getElementById(id);
    if (!el) return;
    e.preventDefault();
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, false);

  /* ---------- Book a demo ---------- */

  document.addEventListener('DOMContentLoaded', function () {
    const bookDemoForm = document.getElementById('jora-book-demo');
    if (!bookDemoForm) return;

    function toggleError(input, show, type = 'required') {
      const fieldContainer = input.closest('.mvp-field');
      const errorSpan = fieldContainer?.querySelector('.mvp-err');
      if (!errorSpan) return;

      if (show) {
        input.classList.add('err');
        if (type === 'invalid' && errorSpan.dataset.msgInvalid) {
          errorSpan.textContent = errorSpan.dataset.msgInvalid;
        } else if (errorSpan.dataset.msgRequired) {
          errorSpan.textContent = errorSpan.dataset.msgRequired;
        }
        errorSpan.removeAttribute('hidden');
      } else {
        input.classList.remove('err');
        errorSpan.setAttribute('hidden', '');
      }
    }

    function isEmailValid(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
    }

    bookDemoForm.querySelectorAll('input[required], textarea[required]').forEach(input => {
      ['input', 'blur'].forEach(eventType => {
        input.addEventListener(eventType, (e) => {
          const isEmailField = input.getAttribute('type') === 'email';
          const val = input.value.trim();

          if (val === '') {
            if (e.type === 'blur') toggleError(input, true, 'required');
          } else if (isEmailField) {
            toggleError(input, !isEmailValid(val), 'invalid');
          } else {
            toggleError(input, false);
          }
        });
      });
    });

    bookDemoForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const form = e.target;
      let isFormValid = true;

      form.querySelectorAll('input[required], textarea[required]').forEach(input => {
        if (!input.value.trim()) {
          toggleError(input, true, 'required');
          isFormValid = false;
        }
      });

      const emailInput = form.querySelector('[name="contact[email]"]');
      if (emailInput && emailInput.value && !isEmailValid(emailInput.value)) {
        toggleError(emailInput, true, 'invalid');
        isFormValid = false;
      }

      if (!isFormValid) return;

      proceedWithSubmission(form);
    });

    // Capture confirmation — pattern mirrors swapToDoneState() on the notify form (JORS-2712):
    // the element is built with document.createElement, never present in the markup at load.
    function injectCaptureConfirmation(container) {
      if (!container || container.querySelector('.mvp-book-success')) return;

      const checkIcon = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none">' +
        '<path d="M5 13l4 4L19 7" stroke="currentColor" stroke-width="2.4" ' +
        'stroke-linecap="round" stroke-linejoin="round"/></svg>';

      const confirmation = document.createElement('div');
      confirmation.className = 'mvp-book-success';
      confirmation.setAttribute('role', 'status');
      confirmation.innerHTML =
        '<div class="mvp-success-check" aria-hidden="true">' + checkIcon + '</div><h3></h3><p></p>';
      confirmation.querySelector('h3').textContent = container.dataset.successTitle || '';
      confirmation.querySelector('p').textContent = container.dataset.successBody || '';

      // JORS-4152: sit above the inline Calendly container, so the booking opens beneath it.
      container.insertBefore(confirmation, container.querySelector('#jora-cal-inline'));
    }

    // The widget script/stylesheet are only needed for the mobile popup; the desktop iframe is self-contained.
    // Loaded ahead of the submit (first focus in the form) so the handoff does not wait on them.
    let calendlyWidgetPromise = null;
    function loadCalendlyWidget() {
      if (window.Calendly) return Promise.resolve();
      if (calendlyWidgetPromise) return calendlyWidgetPromise;

      if (!document.querySelector('link[href*="calendly.com/assets/external/widget.css"]')) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://assets.calendly.com/assets/external/widget.css';
        document.head.appendChild(link);
      }

      calendlyWidgetPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://assets.calendly.com/assets/external/widget.js';
        script.async = true;
        script.onload = resolve;
        script.onerror = () => { calendlyWidgetPromise = null; reject(new Error('Calendly widget failed to load')); };
        document.body.appendChild(script);
      });
      return calendlyWidgetPromise;
    }

    bookDemoForm.addEventListener('focusin', function () {
      const url = document.getElementById('jora-book-form-container')?.dataset.calendlyUrl;
      if (window.innerWidth <= 720 && url && url.trim() !== '') {
        loadCalendlyWidget().catch(err => console.error('Calendly preload error:', err));
      }
    }, { once: true });

    // JORS-4255: the mobile Calendly popup can be closed before a slot is booked. The card must never be
    // left empty: the lead is already captured at submit, so the visitor gets the confirmation back with
    // a way to reopen the booking. Calendly sends no close event for its popup, so the overlay's removal is watched.
    let bookingConfirmed = false;
    window.addEventListener('message', function (e) {
      if (e.origin === 'https://calendly.com' && e.data && e.data.event === 'calendly.event_scheduled') {
        bookingConfirmed = true;
      }
    });

    function watchPopupClose(container, form, prefilledUrl, relay) {
      let seen = !!document.querySelector('.calendly-overlay');
      const observer = new MutationObserver(function () {
        const present = !!document.querySelector('.calendly-overlay');
        if (present) { seen = true; return; }
        if (!seen) return;
        observer.disconnect();
        showAfterPopup(container, form, prefilledUrl, relay);
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    function showAfterPopup(container, form, prefilledUrl, relay) {
      container.querySelectorAll('.mvp-book-after').forEach(el => el.remove());
      const after = document.createElement('div');
      after.className = 'mvp-book-after';
      after.setAttribute('role', 'status');

      if (bookingConfirmed) {
        container.querySelectorAll('.mvp-book-success').forEach(el => el.remove());
        after.className = 'mvp-book-after mvp-book-success';
        after.innerHTML = '<div class="mvp-success-check" aria-hidden="true"><svg width="22" height="22" viewBox="0 0 24 24" fill="none">' +
          '<path d="M5 13l4 4L19 7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></div><h3></h3><p></p>';
        after.querySelector('h3').textContent = container.dataset.bookedTitle || '';
        after.querySelector('p').textContent = container.dataset.bookedBody || '';
        container.appendChild(after);
        return;
      }

      const cta = document.createElement('button');
      cta.type = 'button';
      cta.className = 'btn btn-accent mvp-book-reopen';
      cta.textContent = container.dataset.ctaLabel || '';
      cta.addEventListener('click', function () {
        if (!window.Calendly) return;
        Calendly.initPopupWidget({ url: prefilledUrl });
        watchPopupClose(container, form, prefilledUrl, relay);
      });

      if (!relay.configured) {
        // No relay configured: the Calendly booking is the only capture, so only the way back to it is offered.
        after.appendChild(cta);
        container.appendChild(after);
      } else if (!relay.failed) {
        // The request left the browser (confirmed, or still in flight past the wait cap with keepalive):
        // keep the confirmation visible and offer to reopen the booking. The form stays hidden, so the
        // same lead is never sent twice.
        injectCaptureConfirmation(container);
        after.appendChild(cta);
        container.appendChild(after);
      } else {
        // The send failed outright (network error): give the form back, details kept, so it can be sent again.
        form.style.display = '';
        delete form.dataset.submitting;
        const submitBtn = form.querySelector('.mvp-book-submit');
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.classList.remove('is-loading');
          submitBtn.removeAttribute('aria-busy');
        }
        const notice = document.createElement('p');
        notice.className = 'mvp-book-notice';
        notice.textContent = container.dataset.unconfirmedNotice || '';
        after.appendChild(notice);
        after.appendChild(cta);
        container.insertBefore(after, form);
      }
    }

    // Move the submission logic into a separate function for cleanliness
    async function proceedWithSubmission(form) {
      // Guard against double submits while the handoff is in flight.
      if (form.dataset.submitting === '1') return;
      form.dataset.submitting = '1';

      // Immediate feedback: the visitor sees the click was taken into account.
      const submitBtn = form.querySelector('.mvp-book-submit');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.classList.add('is-loading');
        submitBtn.setAttribute('aria-busy', 'true');
      }

      const container = document.getElementById('jora-book-form-container');
      const endpoint = container?.dataset.leadEndpoint;
      const currentLang = document.documentElement.lang || 'en';
      const calendlyLang = currentLang.toLowerCase().startsWith('fr') ? 'fr' : 'en';
      const calendlyUrl = container?.dataset.calendlyUrl;
      // JORS-4175: Calendly ignores ?locale=, so the booking language comes from the event type itself.
      const calendlyBookingUrl = calendlyLang === 'fr'
        ? 'https://calendly.com/jonathan-joraleka/book-a-demo-fr'
        : 'https://calendly.com/jonathan-joraleka/book-a-demo';

      const formData = {
        name: form.querySelector('input[name="contact[name]"]')?.value || '',
        email: form.querySelector('input[name="contact[email]"]')?.value || '',
        url: form.querySelector('input[name="contact[store_url]"]')?.value || '',
        need: form.querySelector('textarea[name="contact[body]"]')?.value || '',
        lead_token: container?.dataset.leadToken || '',
        locale: calendlyLang
      };
      Object.assign(formData, getAttribution());

      try {
        let requestIssued = false;
        const relayState = { configured: !!endpoint, failed: false };

        if (endpoint) {
          // The wait is capped: a slow relay must not hold the visitor on the form. keepalive lets the
          // request finish in the background; past the cap it is treated like AC-04 (no confirmation).
          const RELAY_WAIT_MS = 1500;
          try {
            const relay = fetch(endpoint, {
              method: 'POST',
              mode: 'no-cors',
              keepalive: true,
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(formData)
            }).then(() => {
              // demo_requested = request issued and answered, whether or not that happens inside the cap
              // (a cold relay answers in about 3 s). The relay call is no-cors, so its HTTP status cannot be
              // read here (JORS-3162): a relay-side rejection still counts. Fires once per submission.
              trackConversion('demo_requested', { form_location: 'book_demo' });
              return true;
            });
            relay.catch(() => { relayState.failed = true; }); // a rejection after the cap must not surface as unhandled
            const cap = new Promise(resolve => setTimeout(() => resolve(false), RELAY_WAIT_MS));
            requestIssued = await Promise.race([relay, cap]);
          } catch (sendErr) {
            // JORS-3557: a relay failure must not block the Calendly handoff; log it and continue.
            relayState.failed = true;
            console.error("Submission error:", sendErr);
          }
        }

        form.style.display = 'none';

        // AC-05: the confirmation renders only on the path where a request was issued.
        if (requestIssued) {
          injectCaptureConfirmation(container);
        }

        // JORS-3166 AC-06 (amended 24/09/2026): with no Calendly URL, the confirmation is the end state.
        // JORS-4152 / JORS-3961 AC-03: with one, the Calendly handoff follows the confirmation.
        // AC-04: relay unreachable (or not configured) — fall back to the Calendly handoff.
        // Restore the live-theme guard: no Calendly URL means no widget on either path.
        if (!calendlyUrl || calendlyUrl.trim() === '') {
          return;
        }

        const prefillQuery = `name=${encodeURIComponent(formData.name)}&email=${encodeURIComponent(formData.email)}`;
        const joiner = calendlyBookingUrl.includes('?') ? '&' : '?';
        const prefilledUrl = `${calendlyBookingUrl}${joiner}${prefillQuery}`;

        if (window.innerWidth <= 720) {
          // Mobile popup: needs widget.js/css (usually already warm from the first focus in the form).
          await loadCalendlyWidget();
          const calContainer = document.getElementById('jora-cal-inline');
          if (calContainer) calContainer.style.display = 'none';
          Calendly.initPopupWidget({ url: prefilledUrl });
          watchPopupClose(container, form, prefilledUrl, relayState);
        } else {
          // Desktop: the iframe is self-contained, so no script has to load first.
          const parent = document.getElementById('jora-cal-inline');
          if (parent) {
            document.querySelector('.mvp-book-grid')?.classList.add('is-calendly-open');
            parent.innerHTML = `
                        <iframe
                            src="${prefilledUrl}"
                            width="100%"
                            height="100%"
                            frameborder="0"
                            style="min-height: 760px; border: none;"
                            allow="microphone; camera; display-capture; autoplay; encrypted-media; geolocation;"
                        ></iframe>`;
          }
        }
      } catch (err) {
        // JORS-3557: no bare alert().
        console.error("Submission error:", err);
      }
    }
  });

  /* ---------- Motion: hero entry + scroll reveals ---------- */
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;

  if (!prefersReduced) {
    root.classList.add('motion-hero', 'motion-reveal', 'motion-mock');
  }

  if ('IntersectionObserver' in window && !prefersReduced) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.mvp-reveal').forEach(function (el) {
      io.observe(el);
    });
  } else {
    document.querySelectorAll('.mvp-reveal').forEach(function (el) {
      el.classList.add('is-in');
    });
  }

  /* ---------- Inline email notify form — JORS-2712 ---------- */
  // JORS-3813: seven merge fields confirmed on the Mailchimp audience (comment 72650).
  var NOTIFY_ATTRIBUTION = true;
  var NOTIFY_MERGE_TAGS = {
    utm_source: 'UTMSOURCE',
    utm_medium: 'UTMMEDIUM',
    utm_campaign: 'UTMCAMPGN',
    utm_content: 'UTMCONTENT',
    utm_term: 'UTMTERM',
    referrer: 'REFERRER',
    landing_path: 'LANDPATH'
  };

  function isValidEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim());
  }

  // JORS-4452 AC-03: a failed sign-up is never silent. The form and the typed address stay,
  // the visitor is told to try again later, in the existing error slot (#email-hint).
  // No automatic retry: a refused domain would only be refused again.
  var NOTIFY_RETRY_MSG = {
    fr: 'Inscription impossible pour le moment. Réessayez plus tard.',
    en: 'Sign-up isn’t possible right now. Please try again later.'
  };

  function clearNotifyRetry(form) {
    if (form.dataset.notifyRetry !== '1') return;
    var hint = form.querySelector('#email-hint');
    if (hint) {
      hint.textContent = hint.dataset.defaultText || hint.textContent;
      hint.hidden = true;
    }
    form.classList.remove('err');
    delete form.dataset.notifyRetry;
  }

  function showNotifyRetry(form) {
    var hint = form.querySelector('#email-hint');
    if (!hint) return;
    if (!hint.dataset.defaultText) hint.dataset.defaultText = hint.textContent.trim();
    var lang = (document.documentElement.lang || 'en').toLowerCase().startsWith('fr') ? 'fr' : 'en';
    hint.textContent = NOTIFY_RETRY_MSG[lang];
    hint.hidden = false;
    form.classList.add('err');
    form.dataset.notifyRetry = '1';
  }

  // JORS-4650: the sign-up no longer goes from the browser to Mailchimp. It goes to the relay with an
  // ALTCHA proof of work (self-hosted widget, no cookie, no third party), and the relay adds the contact.
  // The widget is loaded on the first focus of the field, so the hero never pays for it.
  var altchaScriptLoad = null;

  function loadAltchaScript(src) {
    if (altchaScriptLoad) return altchaScriptLoad;
    altchaScriptLoad = new Promise(function (resolve, reject) {
      if (window.customElements && window.customElements.get('altcha-widget')) { resolve(); return; }
      var tag = document.createElement('script');
      tag.src = src;
      tag.async = true;
      tag.onload = function () { resolve(); };
      tag.onerror = function () { altchaScriptLoad = null; reject(new Error('altcha script')); };
      document.head.appendChild(tag);
    });
    return altchaScriptLoad;
  }

  function startHumanCheck(form) {
    var hc = form._humanCheck;
    if (!hc || !hc.widget) return;
    hc.payload = '';
    hc.state = 'unverified';
    try {
      if (typeof hc.widget.reset === 'function') hc.widget.reset();
      hc.widget.verify();
    } catch (err) { hc.state = 'error'; }
  }

  function prepareHumanCheck(form) {
    if (form._humanCheck) return form._humanCheck;
    var hc = form._humanCheck = { widget: null, payload: '', state: 'idle' };
    var endpoint = form.dataset.notifyEndpoint;
    var src = form.dataset.altchaSrc;
    if (!endpoint || !src) { hc.state = 'error'; return hc; }

    loadAltchaScript(src).then(function () {
      var widget = document.createElement('altcha-widget');
      widget.setAttribute('challengeurl', endpoint + (endpoint.indexOf('?') === -1 ? '?' : '&') + 'action=altcha-challenge');
      widget.setAttribute('auto', 'off');
      widget.setAttribute('hidefooter', '');
      widget.setAttribute('hidelogo', '');
      widget.style.display = 'none';
      widget.addEventListener('statechange', function (ev) {
        var detail = (ev && ev.detail) || {};
        hc.state = detail.state || hc.state;
        hc.payload = detail.state === 'verified' ? (detail.payload || '') : '';
      });
      form.appendChild(widget);
      hc.widget = widget;
      // The element is upgraded on the next tick: start the work once it is.
      setTimeout(function () { startHumanCheck(form); }, 0);
    }).catch(function () { hc.state = 'error'; });
    return hc;
  }

  // Resolves with the payload once the proof of work is done; one restart if it failed or expired.
  function awaitHumanCheck(form, timeoutMs) {
    var hc = prepareHumanCheck(form);
    var started = Date.now();
    var restarted = false;
    return new Promise(function (resolve, reject) {
      (function poll() {
        if (hc.state === 'verified' && hc.payload) { resolve(hc.payload); return; }
        if ((hc.state === 'error' || hc.state === 'expired') && hc.widget) {
          if (restarted) { reject(new Error('human check failed')); return; }
          restarted = true;
          startHumanCheck(form);
        } else if (hc.state === 'error') {
          reject(new Error('human check unavailable'));
          return;
        }
        if (Date.now() - started > timeoutMs) { reject(new Error('human check timeout')); return; }
        setTimeout(poll, 100);
      })();
    });
  }

  document.querySelectorAll('[data-jora-notify]').forEach(function (form) {
    var input = form.querySelector('input[type="email"]');
    var btn = form.querySelector('button[type="submit"]');
    var hint = form.querySelector('#email-hint');
    var check = form.querySelector('#email-check');

    function refreshStates() {
      var val = input.value.trim();
      var valid = isValidEmail(val);

      btn.disabled = (val === '');

      if (val !== '' && !valid) {
        if (hint) hint.hidden = false;
        if (check) check.hidden = true;
        form.classList.add('err');
      } else {
        if (hint) hint.hidden = true;
        if (check) check.hidden = !valid;
        form.classList.remove('err');
      }
    }

    input.addEventListener('input', function () { clearNotifyRetry(form); refreshStates(); });
    input.addEventListener('blur', function () { if (form.dataset.notifyRetry !== '1') refreshStates(); });
    input.addEventListener('focus', function () { prepareHumanCheck(form); }, { once: true });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (input.value || '').trim();

      if (!isValidEmail(email)) {
        refreshStates();
        input.focus();
        trackEmailSubmission('landing_email_submission_error');
        return;
      }

      clearNotifyRetry(form);
      btn.disabled = true;
      var orig = btn.innerHTML;
      btn.innerHTML = '<span style="white-space:nowrap">…</span>';

      var endpoint = form.dataset.notifyEndpoint;
      var listId = form.dataset.mailchimpId;      // EN or FR audience, set by the section settings

      function restoreForm() {
        if (btn) { btn.disabled = false; btn.innerHTML = orig; }
      }

      if (!endpoint || !listId) {
        console.error('Notify sign-up configuration error: missing relay endpoint or audience id.');
        trackEmailSubmission('landing_email_submission_error');
        restoreForm();
        showNotifyRetry(form);
        return;
      }

      var notifyData = {
        action: 'notify',
        email: email,
        list_id: listId,
        locale: (document.documentElement.lang || 'en').toLowerCase().startsWith('fr') ? 'fr' : 'en'
      };
      if (NOTIFY_ATTRIBUTION) {
        try {
          var attr = getAttribution();
          Object.keys(NOTIFY_MERGE_TAGS).forEach(function (k) { notifyData[k] = attr[k] || ''; });
        } catch (err) { /* attribution never blocks the send */ }
      }

      function failed(reason) {
        trackEmailSubmission('landing_email_submission_error');
        console.error('Notify sign-up error:', reason);
        restoreForm();
        showNotifyRetry(form);
        startHumanCheck(form); // a proof of work is used once: prepare the next one
      }

      awaitHumanCheck(form, 25000).then(function (payload) {
        notifyData.altcha = payload;
        var controller = typeof AbortController === 'function' ? new AbortController() : null;
        var timer = setTimeout(function () { if (controller) controller.abort(); }, 20000);
        // text/plain keeps this a simple request (no preflight); the relay answers JSON with HTTP 200.
        return fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify(notifyData),
          signal: controller ? controller.signal : undefined
        }).then(function (res) { clearTimeout(timer); return res.json(); },
                function (err) { clearTimeout(timer); throw err; });
      }).then(function (data) {
        var result = data && data.result;
        if (result === 'success' || result === 'already') {
          trackEmailSubmission('landing_email_submission_success');
          // A new subscription only: "already subscribed" is not a new lead.
          if (result === 'success') trackConversion('notify_me_submitted', { form_location: 'hero' });
          swapToDoneState(form, result === 'already' ? 'already' : 'success');
        } else {
          failed((data && data.reason) || 'refused');
        }
      }).catch(function (err) {
        failed(err && err.message ? err.message : 'network');
      });
    });
  });

  function swapToDoneState(form, status) {
    status = status || 'success';
    var accepted = (status === 'success' || status === 'already');
    var lang = (document.documentElement.lang || 'en').toLowerCase().startsWith('fr') ? 'fr' : 'en';

    var messages = {
      'success': (lang === 'fr' ? "Vous êtes sur la liste ! On vous écrit au lancement." : "You’re on the list! We’ll email you at launch."),
      'already': (lang === 'fr' ? "Vous êtes déjà sur la liste." : "You’re already on the list."),
      'network': (lang === 'fr' ? "Votre inscription n’a pas pu être envoyée. Rechargez la page et réessayez." : "Your sign-up could not be sent. Please reload the page and try again."),
      'error':   (lang === 'fr' ? "Saisissez une adresse e-mail valide." : "Please enter a valid email address.")
    };

    var message = messages[status] || messages['error'];

    var successIcon = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7.5l3 3 7-7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var errorIcon   = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><circle cx="7" cy="7" r="6" stroke="currentColor" stroke-width="2"/><path d="M7 4v4M7 10h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

    var container = document.createElement('div');
    container.className = 'mvp-notify ' + (accepted ? 'mvp-notify-done' : 'mvp-notify-error');
    container.setAttribute('role', 'status');

    var iconClass = accepted ? 'mvp-notify-check' : 'mvp-notify-icon';
    container.innerHTML = '<span class="' + iconClass + '">' + (accepted ? successIcon : errorIcon) + '</span>' +
                          '<span class="mvp-notify-msg">' + message + '</span>';

    form.replaceWith(container);
  }

})();


document.addEventListener('DOMContentLoaded', function () {
  var hostname = window.location.hostname;
  var currentLang = hostname.startsWith('fr.') ? 'fr' : 'en';

  document.querySelectorAll('.lang-mini button').forEach(function (btn) {
    if (btn.getAttribute('data-value') === currentLang) {
      btn.classList.add('active');
      btn.setAttribute('aria-selected', 'true');
    } else {
      btn.classList.remove('active');
      btn.setAttribute('aria-selected', 'false');
    }
  });
});

document.querySelectorAll('.lang-mini button').forEach(function (button) {
  button.addEventListener('click', function () {
    var selectedLang = this.getAttribute('data-value');
    // JORS-3816: the language is chosen by the host, so drop a /fr or /en path prefix.
    // Left on, Shopify redirects the prefixed path to the bare one and loses the query string.
    var pathName = window.location.pathname.replace(/^\/(fr|en)(?=\/|$)/i, '') || '/';
    var searchParams = window.location.search;

    // JORS-3813: carry the first touch of the visit across the host switch, in the URL.
    try {
      if (typeof window.joraGetAttribution === 'function') {
        var attr = window.joraGetAttribution();
        var carried = new URLSearchParams(searchParams);
        ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
          if (attr[k]) carried.set(k, attr[k]);
        });
        carried.set('jl_ref', attr.referrer || '');
        carried.set('jl_lp', attr.landing_path || '');
        searchParams = '?' + carried.toString();
      }
    } catch (e) { /* switch with the original query string */ }

    var myDate = new Date();
    myDate.setMonth(myDate.getMonth() + 12);

    document.cookie = 'store_language=' + selectedLang + '; expires=' + myDate.toUTCString() + '; path=/; domain=joraleka.com; SameSite=Lax; Secure';

    var urlMap = {
      'fr': '//fr.joraleka.com',
      'en': '//joraleka.com'
    };

    var targetBase = urlMap[selectedLang] || '//joraleka.com';

    setTimeout(function () {
      window.location.href = targetBase + pathName + searchParams;
    }, 500);
  });
});
